import { render } from "./ProviderList.vue?vue&type=template&id=6a271b68&scoped=true"
import script from "./ProviderList.vue?vue&type=script&lang=js"
export * from "./ProviderList.vue?vue&type=script&lang=js"

import "./ProviderList.vue?vue&type=style&index=0&id=6a271b68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a271b68"]])

export default __exports__